document.addEventListener('DOMContentLoaded', function () {
    grecaptcha.ready(function () {
        grecaptcha.execute(RECAPTCHA_SITE_KEY, { action: 'contact' })
            .then(function (token) {
                const input = document.getElementById('recaptcha_token');
                if (input) {
                    input.value = token;
                }
            });
    });
});
